import { render, staticRenderFns } from "./labelModel.vue?vue&type=template&id=30092e78"
import script from "./labelModel.vue?vue&type=script&lang=js"
export * from "./labelModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30092e78')) {
      api.createRecord('30092e78', component.options)
    } else {
      api.reload('30092e78', component.options)
    }
    module.hot.accept("./labelModel.vue?vue&type=template&id=30092e78", function () {
      api.rerender('30092e78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/categoryLabelManage/labelModel.vue"
export default component.exports